<div class="crud-container">
    <div class="crud-header">
        <div class="crud-title-wrapper">
            <app-utility-header
            [title]="'SIDENAV.PROFILE'"
            [utilityName]="'UTILITY_MANAGEMENT.ENTITY_MODEL_CUSTOMIZATION' | translate"
            (backButtonClicked)="handleBackButtonClicked()"
            ></app-utility-header>

            <div class="main-tabs">
                <div *ngFor="let item of mainTabItems; let i = index" class="main-tab" [ngClass]="{'active': selectedMainTab == item}"
                    (click)="selectMainTab(item, i)">
                    {{ item }}
                </div>
            </div>


            <div class="toggle-container" *ngIf="selectedMainTab === 'Assets'">
                <ng-container *ngIf="substationTemplates.length">
                    <div class="toggle-button"
                         *ngFor="let tpl of substationTemplates"
                         (click)="selectEntityModel(EMCType.SubstationTemplate, tpl.id)"
                         [class.active]="selectedSubstationTemplate?.id === tpl.id">
                        <span>{{ tpl.className }}</span>
                    </div>
                </ng-container>
                <div class="toggle-button" (click)="selectEntityModel(EMCType.TransmissionStation)" [ngClass]="{'active': entityType == EMCType.TransmissionStation }"><span>{{ 'ENTITY_MODEL_CUSTOMIZATION.TS' | translate }}</span></div>
                <div class="toggle-button" (click)="selectEntityModel(EMCType.InjectionSubstation)" [ngClass]="{'active': entityType == EMCType.InjectionSubstation }"><span>{{ 'ENTITY_MODEL_CUSTOMIZATION.IS' | translate }}</span></div>
                <div class="toggle-button" (click)="selectEntityModel(EMCType.DistributionSubstation)" [ngClass]="{'active': entityType ==  EMCType.DistributionSubstation}"><span>{{ 'ENTITY_MODEL_CUSTOMIZATION.DS' | translate }}</span></div>
                <div class="toggle-button" (click)="selectEntityModel(EMCType.MainFeeder)" [ngClass]="{'active': entityType == EMCType.MainFeeder}"><span>{{ 'ENTITY_MODEL_CUSTOMIZATION.MAIN_FEEDER' | translate }}</span></div>
                <div class="toggle-button" (click)="selectEntityModel(EMCType.SecondaryFeeder)" [ngClass]="{'active': entityType ==  EMCType.SecondaryFeeder}"><span>{{ 'ENTITY_MODEL_CUSTOMIZATION.SECONDARY_FEEDER' | translate }}</span></div>
                <div class="toggle-button" (click)="selectEntityModel(EMCType.Pole)" [ngClass]="{'active': entityType ==  EMCType.Pole}"><span>{{ 'ENTITY_MODEL_CUSTOMIZATION.POLES' | translate }}</span></div>
                <div class="toggle-button" (click)="selectEntityModel(EMCType.Device)" [ngClass]="{'active': entityType ==  EMCType.Device}"><span>{{ 'ENTITY_MODEL_CUSTOMIZATION.DEVICES' | translate }}</span></div>
                <div class="toggle-button" (click)="selectEntityModel(EMCType.Building)" [ngClass]="{'active': entityType ==  EMCType.Building}"><span>{{ 'ENTITY_MODEL_CUSTOMIZATION.BUILDINGS' | translate }}</span></div>
                <div class="toggle-button" (click)="selectEntityModel(EMCType.Meter)" [ngClass]="{'active': entityType ==  EMCType.Meter}"><span>{{ 'ENTITY_MODEL_CUSTOMIZATION.METERS' | translate }}</span></div>
                <div class="toggle-button" (click)="selectEntityModel(EMCType.Customer)" [ngClass]="{'active': entityType ==  EMCType.Customer}"><span>{{ 'ENTITY_MODEL_CUSTOMIZATION.CUSTOMERS' | translate }}</span></div>
            </div>
            <div class="toggle-container" *ngIf="selectedMainTab === 'Equipments'">
                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.PowerTransformer)"
                    [ngClass]="{'active': cimClass == CimClass.PowerTransformer}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.POWER_TRANSFORMER' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.AcLineSegment)"
                    [ngClass]="{'active': cimClass == CimClass.AcLineSegment}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.AC_LINE_SEGMENT' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.SwitchGear)"
                    [ngClass]="{'active': cimClass == CimClass.SwitchGear}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.SWITCH_GEAR' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.Conductor)"
                    [ngClass]="{'active': cimClass == CimClass.Conductor}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.CONDUCTOR' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.Busbar)"
                    [ngClass]="{'active': cimClass == CimClass.Busbar}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.BUSBAR' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.Junction)"
                    [ngClass]="{'active': cimClass == CimClass.Junction}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.JUNCTION' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.Jumper)"
                    [ngClass]="{'active': cimClass == CimClass.Jumper}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.JUMPER' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.Fuse)"
                    [ngClass]="{'active': cimClass == CimClass.Fuse}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.FUSE' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.Disconnector)"
                    [ngClass]="{'active': cimClass == CimClass.Disconnector}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.DISCONNECTOR' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.GroundDisconnector)"
                    [ngClass]="{'active': cimClass == CimClass.GroundDisconnector}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.GROUND_DISCONNECTOR' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.LoadBreakSwitch)"
                    [ngClass]="{'active': cimClass == CimClass.LoadBreakSwitch}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.LOAD_BREAK_SWITCH' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.Breaker)"
                    [ngClass]="{'active': cimClass == CimClass.Breaker}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.BREAKER' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.Ground)"
                    [ngClass]="{'active': cimClass == CimClass.Ground}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.GROUND' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.Recloser)"
                    [ngClass]="{'active': cimClass == CimClass.Recloser}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.RECLOSER' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.Cut)"
                    [ngClass]="{'active': cimClass == CimClass.Cut}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.CUT' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.Sectionaliser)"
                    [ngClass]="{'active': cimClass == CimClass.Sectionaliser}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.SECTIONALISER' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.PetersenCoil)"
                    [ngClass]="{'active': cimClass == CimClass.PetersenCoil}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.PETERSEN_COIL' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.ShuntCompensator)"
                    [ngClass]="{'active': cimClass == CimClass.ShuntCompensator}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.SHUNT_COMPENSATOR' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.FrequencyConverter)"
                    [ngClass]="{'active': cimClass == CimClass.FrequencyConverter}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.FREQUENCY_CONVERTER' | translate }}</span>
                </div>

                <div class="toggle-button"
                    (click)="selectCimClass(CimClass.StaticVarCompensator)"
                    [ngClass]="{'active': cimClass == CimClass.StaticVarCompensator}">
                    <span>{{ 'ENTITY_MODEL_CUSTOMIZATION.EQUIPMENTS.STATIC_VAR_COMPENSATOR' | translate }}</span>
                </div>

                </div>
        </div>
    </div>
    
    <app-emc-asset 
        *ngIf="selectedMainTab == 'Assets'" 
        [entityType]="entityType" 
        [substationTemplate]="selectedSubstationTemplate" 
        [selectedMainTab]="selectedMainTab"
    ></app-emc-asset>
    <app-emc-asset 
        *ngIf="selectedMainTab == 'Equipments'" 
        [entityType]="entityType" 
        [cimClass]="cimClass" 
        [selectedMainTab]="selectedMainTab"
    ></app-emc-asset>
</div>